import { Icon, Intent, Position, Tooltip } from '@blueprintjs/core'
import { Promise as BbPromise } from 'bluebird'
import { lang } from 'enablex/shared'
import React, { FC, Fragment, useEffect, useState } from 'react'
import api from '~/app/api'

interface Props {
  bot: string
  languages: string[]
  isPublished?: boolean
}

export const NeedsTrainingWarning: FC<Props> = (props: Props) => {
  const { bot, languages, isPublished } = props

  const [needsTraining, setNeedsTraining] = useState(false)

  useEffect(() => {
    const axios = api.getSecured({ useV1: true })

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    const timeout = setTimeout(() => {
      BbPromise.map(languages, async lang => {
        try {
          const { data } = await axios.get(`bots/${bot}/mod/nlu/training/${lang}`)
          //console.log('botId : ', bot, ' data : ', data)
          return data.status === 'needs-training'
        } catch (err) {
          return false
        }
      }).then(langNeedsTraining => {
        setNeedsTraining(langNeedsTraining.some(Boolean))
      }).catch(error => {
        setNeedsTraining(false)
      })
    }, 1000)

    // Cleanup function to clear the timeout if the component unmounts or if you want to cancel it for some reason
    return () => {
      clearTimeout(timeout)
    }
  }, [isPublished])

  const message = () => (
    <Fragment>
      <div>{lang.tr('admin.needsTraining')}&nbsp;{lang.tr('admin.howToTrain')}</div>
    </Fragment>
  )

  if (needsTraining) {
    return (
      <Tooltip intent={Intent.WARNING} content={message()} position={Position.TOP}>
        <Icon icon="warning-sign" intent={Intent.WARNING} style={{ marginLeft: 10 }} />
      </Tooltip>
    )
  }
  return null
}
